import $ from 'jquery';
import _ from 'lodash';
import { TweenMax } from 'gsap';
import common from '../base/common';
import emitter from '../base/emitter';
import scroller from '../components/scroller';
import '../../vendors/gsap/src/uncompressed/utils/Draggable';
import '../../vendors/gsap/src/uncompressed/plugins/ThrowPropsPlugin';
import '../../vendors/gsap/src/uncompressed/plugins/ScrollToPlugin';

class SectionSlider{


    constructor(){

        // INITIALIZATIONS

        this.$slider = $('#SectionSlider');
        this.$slides = this.$slider.find('.SectionSlider__Item');
        this.$dragger = this.$slider.find('.SectionSlider__Container');
        this.$sliderButtons = $('[data-slider]');
        this.snapPoints = [];
        this.slideIndex = 0;
        this.isDragging = false;
        this.$cursor = $('.cursor');
        this.factor = 1;
        this.ratio = 0.8;
        this.isFullscreen = this.$slider.hasClass('__fullscreen') ? 1 : 0;
        this.perspective = 1200;
        this.$loadBar = $('.LoadBar');
        this.$logo = $('#main-logo');

        // BIND EVENTS

        this.onReszie = this.onResize.bind(this);
        this._onDragStart = this._onDragStart.bind(this);
        this._onDrag = this._onDrag.bind(this);
        this._onDragEnd = this._onDragEnd.bind(this);
        this._onPress = this._onPress.bind(this);
        this.openActive = this.openActive.bind(this);
        this.onReszie = this.onResize.bind(this);
        this.updateUI = this.updateUI.bind(this);
        this.mouseEvents = this.mouseEvents.bind(this);
        this.keyboardNavigation = this.keyboardNavigation.bind(this);
        this.toggleSlideshow = this.toggleSlideshow.bind(this);
        this.toggleCallback = this.toggleCallback.bind(this);
        this.goToButton = this.goToButton.bind(this);
        this.onLoad = this.onLoad.bind(this);
        this.goToSlide = this.goToSlide.bind(this);

        common.$window.on('resize.slider', _.debounce(this.onResize, 1000));
        common.$window.on('orientationchange.slider', _.debounce(this.onResize, 1000));
        emitter.on('sectionSlider:toggle', this.toggleSlideshow);
        common.$body.on('click', '[data-slider]', this.goToButton);
        common.$body.on('click', '[data-slider-to]', this.goToSlide);

        this.sliderHeight = common.screen.height;

        // INIT EVENTS

        emitter.on('page:load', this.onLoad);

        this.onResize();
        this.init();

    }

    onResize(e){

        // if(e !== undefined && (e.type == 'resize' && Modernizr.touchevents)) return;
        // this.sliderHeight = common.screen.height;
        // $('.home-slider, .SectionSlider').height(common.screen.height);
        TweenMax.set(this.$dragger, {
            x: this.slideIndex * (common.screen.width * (this.isFullscreen ? 1 : this.ratio)) * -1,
        });

    }

    bindEvents(){

        common.$window.on('keydown.slider', this.keyboardNavigation);
        this.$dragger.on('click.slider mouseover.slider mouseout.slider mousemove.slider', this.mouseEvents);
        this.$slider.on('click', 'a', this.openActive);

    }

    unbindEvents(){

        common.$window.off('keydown.slider', this.keyboardNavigation);
        this.$dragger.off('click.slider mouseover.slider mouseout.slider mousemove.slider', this.mouseEvents);
        this.$slider.off('click', 'a', this.openActive);

    }

    init(){


        this.draggable = Draggable.create(this.$dragger,{

            cursor: 'grab',
            type: 'x',
            bounds: '#SectionSlider',
            throwProps: true,
            edgeResistance: 0.5,
            zIndexBoost:false,
            force3D: true,
            lockAxis: true,
            snap: {
                x: (endValue) => {
                    return Math.round(Math.abs(endValue) / (common.screen.width * (this.isFullscreen ? 1 : this.ratio))) * (common.screen.width * (this.isFullscreen ? 1 : this.ratio) * -1);
                }
            },
            onThrowComplete: () => {},
            onDragStart: this._onDragStart,
            onDrag: this._onDrag,
            onDragEnd: this._onDragEnd,
            onPress: this._onPress,

        })

        this.$slides.each((index, item) => {

            if($(item).hasClass('__active')){

                this.slideIndex = index;
                this.$currentSlide = this.$slides.eq(index);
                TweenMax.set(this.$dragger, {
                    x: this.slideIndex * (common.screen.width * (this.isFullscreen ? 1 : this.ratio)) * -1,
                });

            }

        })

        if(!this.isFullscreen) {

            this.bindEvents();
            this.$slider.addClass('__draggable');
            scroller.disable();
            common.$body.addClass('show-cursor');

        }else{

            this.draggable[0].disable();
            this.$slider.removeClass('__draggable');
            scroller.enable();
            common.$body.removeClass('show-cursor');

        }

        // temporany disabled
        // TweenMax.set(this.$slides.not(':eq(' + this.slideIndex + ')').find('.SectionSlider__ItemBg'),{
        //     opacity: 0.2
        // })
        //
        // TweenMax.set(this.$slides.not(':eq(' + this.slideIndex + ')').find('.SectionSlider__ItemText'),{
        //     opacity: 0
        // })

    }

    _onPress(){

        this.$slider.addClass('__dragging');

    }

    _onDragStart(){

        this.isDragging = true;

        this.animation = {

            start: this.getPosition(),
            offset: common.screen.width * 0.45

        }

    }

    _onDrag(instance){

        // temporany disabled
        // this.animation.current = this.getPosition();
        // this.$slides.removeClass('__changing')
        //
        // if(this.animation.current - this.animation.start < 0){
        //
        //     // sto andando avanti
        //     this.animation.$next = this.$slides.eq(this.slideIndex + 1);
        //     this.animation.$next.addClass('__changing');
        //
        // }else{
        //
        //     // sto andando indietro
        //     this.animation.$next = this.$slides.eq(this.slideIndex - 1);
        //     this.animation.$next.addClass('__changing');
        //
        // }
        //
        // let offsetPercent = (this.animation.offset - Math.abs(this.animation.current)) / this.animation.offset;
        //
        // if(offsetPercent >= 0){
        //
        //     TweenMax.set(this.$currentSlide.find('.SectionSlider__ItemText'), {opacity: offsetPercent})
        //     TweenMax.set(this.$currentSlide.find('.SectionSlider__ItemBg'), {opacity: 0.2 + offsetPercent})
        //     if(this.animation.$next.length){
        //
        //         TweenMax.set(this.animation.$next.find('.SectionSlider__ItemText'), {opacity: 0.2 + 1 - offsetPercent})
        //         TweenMax.set(this.animation.$next.find('.SectionSlider__ItemBg'), {opacity: 0.2 + 1 - offsetPercent})
        //
        //     }
        //
        // }

    }

    _onDragEnd(){

        this.$slider.removeClass('__dragging');

        setTimeout(() => {
            let pos = Math.abs(this.getPosition());
            this.slideIndex = Math.round(pos / (common.screen.width * (this.isFullscreen ? 1 : this.ratio)));
            this.isDragging = false;
            this.updateUI();
        },600)


        // temporany disabled
        // this.$slider.removeClass('__dragging');
        // TweenMax.to(this.$slides.eq(this.slideIndex).find('.SectionSlider__ItemText'), 0.5, {opacity: 1})
        // TweenMax.to(this.$slides.eq(this.slideIndex).find('.SectionSlider__ItemBg'), 0.5, {opacity: 1})
        //
        // TweenMax.to(this.$slides.not(':eq('+this.slideIndex+')').find('.SectionSlider__ItemText'), 0, {opacity: 0})
        // TweenMax.to(this.$slides.not(':eq('+this.slideIndex+')').find('.SectionSlider__ItemBg'), 0.2, {opacity: 0.2})
        //
        // this.$slides.removeClass('__changing');
        // this.$slides.removeClass('__active');
        // this.$currentSlide = this.$slides.eq(this.slideIndex)
        // this.$currentSlide.addClass('__active');

    }

    getPosition(){

        return this.$dragger[0]._gsTransform.x;

    }

    keyboardNavigation(e){

        let keyCode = e.which || e.keyCode;

        if(keyCode == 37)
            this.prevSlide();
        else if(keyCode == 39)
            this.nextSlide();

    }

    mouseEvents(e){

        switch(e.type){

            case 'click':

                if($(e.target).is('a, button') || this.isDragging) return;

                e.preventDefault();
                this.$slider.removeClass('__dragging');

                if(e.clientX <= common.screen.width * 0.3 && !Modernizr.touchevents)
                    this.prevSlide();

                if(e.clientX >= common.screen.width * 0.6 && !Modernizr.touchevents)
                    this.nextSlide();

                if(e.clientX > common.screen.width * 0.3 && e.clientX < common.screen.width * 0.6 && !this.isDragging || Modernizr.touchevents){
                    this.draggable[0].disable();
                    this.openActive();
                }

                break;

            case 'mouseover':

                if(!common.$body.hasClass('show-cursor') && !$(e.target).is('a, button')) {
                    common.$body.addClass('show-cursor')
                }
                break;

            case 'mouseout':
                if(common.$body.hasClass('show-cursor')) {
                    common.$body.removeClass('show-cursor');
                }
                break;

            case 'mousemove':

                if(e.clientX <= common.screen.width * 0.3 && this.slideIndex > 0)
                    this.$cursor.attr('class', 'cursor cursor--left')

                if(e.clientX >= common.screen.width * 0.6 && this.slideIndex < this.$slides.length - 1)
                    this.$cursor.attr('class', 'cursor cursor--right')

                if(e.clientX > common.screen.width * 0.3 && e.clientX < common.screen.width * 0.6)
                    this.$cursor.attr('class', 'cursor');

                TweenMax.set(this.$cursor, {x: e.clientX, y: e.clientY});
                break;

        }


    }

    prevSlide(){

        if(this.slideIndex == 0) return;

        this.$slides.removeClass('__active');
        this.slideIndex --;
        let toPos = (this.slideIndex) * common.screen.width * (this.isFullscreen ? 1 : this.ratio) * -1;
        TweenMax.to(this.$dragger, 2, {x: toPos, ease: Power4.easeInOut, onComplete: this.updateUI })

    }

    nextSlide(){

        if(this.slideIndex == this.$slides.length - 1) return;
        this.slideIndex ++;
        let toPos = (this.slideIndex) * common.screen.width * (this.isFullscreen ? 1 : this.ratio) * -1;
        TweenMax.to(this.$dragger, 2, {x: toPos, ease: Power4.easeInOut, onComplete: this.updateUI })

    }

    updateUI(){

        this.$slides.removeClass('__active');
        this.$slides.eq(this.slideIndex).addClass('__active');

    }

    openActive(e){

        let href;

        if(e != undefined) {
            e.preventDefault();
            href = e.currentTarget.href;
        }else
            href = this.$slides.eq(this.slideIndex).find('a').eq(0).attr('href');

        this.toggleSlideshow();
        emitter.emit('paginator:open', href);

    }

    openFullscreen(){

        let d = $.Deferred();

        if(this.isFullscreen)
            d.resolve()
        else
            this.toggleSlideshow();

        return d.promise();

    }

    closeFullscreen(){

        let d = $.Deferred();

        if(!this.isFullscreen)
            d.resolve();
        else
            d = this.toggleSlideshow();

        return d.promise();

    }

    toggleSlideshow(){

        let d = $.Deferred(),
            tl = new TimelineMax({ onComplete: () => {
                setTimeout(() => {
                    this.toggleCallback();
                    d.resolve();
                },300);
            }}),
            zValue = 0;

        this.$slides.find('.SectionSlider__ItemBg').addClass('willtransform');
        this.$slider.addClass('willtransform');

        if(!this.isFullscreen){

            scroller.enable(true);
            common.$body.removeClass('show-fullscreen');
            zValue = this.perspective - this.perspective * this.ratio;

            tl.add([
                TweenMax.to(this.$slides.find('.SectionSlider__ItemLink, .SectionSlider__ItemText .Subtitle'), 0.5, {opacity: 0}),
                TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleLine'), 0.5, {width: '0%', ease: Power3.easeInOut}),
                TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleHero'), 0.5, {y: '100%', delay: 0.3, ease: Power3.easeInOut}),
            ]);
            tl.add([
                TweenMax.to(this.$slides.find('.SectionSlider__ItemBg'),1,{ x: '-50%', y: '-50%', scale: 1, ease: Power4.easeInOut }),
                TweenMax.to(this.$slider, 1, { x: '-50%', y: '-50%', z: zValue + 'px', ease: Power4.easeInOut })
            ]);
            // tl.add([
            // ]);


        }else{

            scroller.disable(true);
            common.$body.addClass('show-fullscreen');
            zValue = this.perspective - (this.perspective / this.ratio);

            tl.add([
                TweenMax.to(this.$slides.find('.SectionSlider__ItemLink, .SectionSlider__ItemText .Subtitle'), 0.5, {opacity: 0}),
                TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleLine'), 0.5, {width: '0%', ease: Power3.easeInOut}),
                TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleHero'), 0.5, {y: '100%', delay: 0.3, ease: Power3.easeInOut}),
            ]);
            tl.add([
                TweenMax.to(this.$slides.find('.SectionSlider__ItemBg'),1,{ x: '-50%', y: '-50%', scale: this.ratio, ease: Power4.easeInOut }),
                TweenMax.to(this.$slider, 1, { x: '-50%', y: '-50%', z: zValue + 'px', ease: Power4.easeInOut })
            ]);
            // tl.add([
            // ]);

        }

        return d.promise();

    }

    toggleCallback(){

        if(this.isFullscreen){

        if($('.bgs--news-detail').length){

            let $title = this.$slides.last().find('.TitleHero');
            $title.text($title.data('text'));

            TweenMax.to($('.SectionSlider__ItemBg.SectionSlider__ItemBg--detail'), 0.5, {opacity: 0, onComplete: () => {

                $('.SectionSlider__ItemBg.SectionSlider__ItemBg--detail').remove();

            }})

        }

        }

        this.isFullscreen = !this.isFullscreen;
        this.$slides.find('.SectionSlider__ItemBg').removeClass('willtransform');
        this.$slider.removeClass('willtransform');

        TweenMax.set(this.$slider, {
            x: '-50%',
            y: '-50%',
            z: 0
        });

        if(this.isFullscreen){

            this.draggable[0].disable();
            this.$slider.addClass('__fullscreen');
            this.$slider.removeClass('__draggable __dragging');
            this.unbindEvents();
            common.$body.removeClass('show-cursor');

        }else{

            this.draggable[0].enable();
            this.$slider.addClass('__draggable');
            this.$slider.removeClass('__fullscreen');
            this.bindEvents();
            common.$body.addClass('show-cursor');

        }

        TweenMax.set(this.$dragger, {
            x: this.slideIndex * (common.screen.width * (this.isFullscreen ? 1 : this.ratio)) * -1,
        });

        TweenMax.to(this.$slides.find('.SectionSlider__ItemText .Subtitle'), 0.5, {opacity: 1, delay: 0.5});
        if(this.isFullscreen)
            TweenMax.to(this.$slides.find('.SectionSlider__ItemLink--scroll'), 0.5, {opacity: 1, delay: 0.5});
        else
            TweenMax.to(this.$slides.find('.SectionSlider__ItemLink.Link'), 0.5, {opacity: 1, delay: 0.5});
        TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleLine'), 0.8, {width: '100%', ease: Power3.easeInOut});
        TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleHero'), 0.8, {y: '0%', delay: 0.3, ease: Power3.easeInOut});

    }

    goToButton(e){

        e.preventDefault();
        let index = e.currentTarget.dataset.slider;

        if(!index) return;

        TweenMax.to(window, 1, { scrollTo: { y: 0, autoKill:false }, ease: Power4.easeInOut, onComplete: () => {

            this.goToAndOpen(index)

        }})

    }

    goToSlide(e){

        e.preventDefault();
        let index = e.currentTarget.dataset.sliderTo;

        if(index == undefined) return;

        TweenMax.to(window, 1, { scrollTo: { y: 0, autoKill:false }, ease: Power4.easeInOut, onComplete: () => {
            this.goToAndOpen(index, false)
        }})

    }

    goToAndOpen(index, openPage){

        if(index == this.slideIndex) return;
        openPage = openPage === undefined ? true : openPage;

        console.log(openPage);

        let d = $.Deferred();

        d = this.closeFullscreen();
        d.done(() => {

            this.slideIndex = index;
            TweenMax.killTweensOf(this.$dragger);
            TweenMax.to(this.$dragger, 2, {x: this.slideIndex * (common.screen.width * (this.isFullscreen ? 1 : this.ratio)) * -1, ease: Power4.easeInOut, onComplete: () => {
                this.updateUI();
                if(openPage)
                    this.openActive();
            }});

        });

    }

    onLoad(){

        var tl = new TimelineMax();
        TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleLine'), 0.8, {width: '100%', ease: Power3.easeInOut});
        TweenMax.to(this.$slides.find('.SectionSlider__ItemText .TitleHero'), 0.8, {y: '0%', delay: 0.3, ease: Power3.easeInOut});
        TweenMax.to(this.$slides.find('.Subtitle'), 0.5, { opacity: 1, delay: 1});

    }

}

export default new SectionSlider();


// WEBPACK FOOTER //
// ./js/components/sectionSlider.js